export default __webpack_public_path__ + "static/icon-28-3-50b45446b2e5c0ea245b93dd8fc17a40.png";